import React, { useRef, useState } from "react";
import moment from "moment";
import { Button } from "react-bootstrap";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../Include/Footer";
import ItemSelectionModal from "../../Components/MaterialReceive/ItemSelectionModal";
import SelectedItemsForm from "../../Components/MaterialReceive/SelectedItemsForm";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { managetMaterialReceive } from "../../../../Store/Erp/MaterialReceive/manageMaterialData";
import { managetMaterialReceiveItem } from "../../../../Store/Erp/MaterialReceive/ManageMaterialItem";
import { useLocation, useNavigate } from "react-router-dom";
import { viewMaterialReceiveData } from "../../../../Store/Erp/MaterialReceive/ViewMaterialData";
import Swal from "sweetalert2";

const ManageMaterialReceive = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { state: data } = useLocation();

  const project_id = localStorage.getItem("U_PROJECT_ID");

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [deletedItems, setDeletedItems] = useState([]);

  const [form, setForm] = useState({
    date: data?.date
      ? moment(data.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
  });

  const editviewItems = useSelector(
    (state) => state?.viewMaterialReceiveData?.user?.data
  );
  const editItemList = editviewItems?.list || [];

  useEffect(() => {
    if (!data?._id || !editItemList?.length) return;

    const mappedItems = editItemList.map((row) => ({
      ui_id: `edit_${row._id}`,
      _id: row._id,
      issue_detail_id: row.issue_detail_id,
      item_id: row.item_id,

      voucher_no: row?.itemDetailsData?.voucher_no || "-",

      itemsDetails: {
        _id: row.itemDetailsData?._id,
        name: row.itemDetailsData?.name,
        category: row.itemDetailsData?.category,
        unit: row.itemDetailsData?.unit,
        qty: row.itemDetailsData?.qty,
        remaining_erp_qty: row.itemDetailsData?.remaining_erp_qty,
        erp_acc_qty: row.itemDetailsData?.erp_acc_qty,
      },

      // quantities
      receive_quantity: row.receive_quantity,
      quantity: row.quantity,
      original_quantity: row.quantity,
      rej_quantity: row.rej_quantity,

      // uom
      uom: row.uomData?._id,

      // misc
      heat_no: row.heat_no,
      nos: row.nos,
      length: row.length,
      width: row.width,
      remarks: row.remarks,

      // QC
      is_qc: row.is_qc,
      qc_nos: row.qc_nos,
      qc_length: row.qc_length,
      qc_width: row.qc_width,
      qc_remarks: row.qc_remarks,
    }));

    setSelectedItems(mappedItems);
  }, [data?._id, editItemList]);

  useEffect(() => {
    if (data?._id) {
      setForm({
        date: data?.date
          ? moment(data.date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
      });
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      const payload = {
        issue_main_id: data._id,
      };
      dispatch(viewMaterialReceiveData(payload));
    }
  }, [data?._id]);

  const unitData = useSelector((state) => state?.getUnit?.user?.data);

  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.date) newErrors.date = "Date is required";

    selectedItems.forEach((item) => {
      // const remainingQty = Number(item?.itemsDetails?.remaining_erp_qty || 0);

      const remainingQty =
        (item.itemsDetails?.remaining_erp_qty || 0) +
        (item.original_quantity || 0);

      if (!item.receive_quantity || item.receive_quantity <= 0) {
        newErrors[`receive_quantity_${item.ui_id}`] =
          "Enter valid receive quantity";
      } else if (item.receive_quantity > remainingQty) {
        newErrors[
          `receive_quantity_${item.ui_id}`
        ] = `Receive quantity cannot exceed available quantity (${remainingQty})`;
      }

      if (!item.quantity || item.quantity < 0) {
        newErrors[`quantity_${item.ui_id}`] = "Enter valid accepted quantity";
      } else if (item.quantity > item.receive_quantity) {
        newErrors[
          `quantity_${item.ui_id}`
        ] = `Accepted quantity cannot exceed received quantity (${item.receive_quantity})`;
      }

      if (!item.uom || item.uom === "") {
        newErrors[`uom_${item.ui_id}`] = "UOM is required";
      }

      if (!item.heat_no || item.heat_no === "") {
        newErrors[`heat_no_${item.ui_id}`] = "heat no is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const createDetailedItem = (item) => {
    const defaultItem = {
      receive_quantity: "",
      quantity: "",
      nos: "",
      heat_no: "",
      length: "",
      width: "",
      topbottom_thickness: "",
      width_thickness: "",
      normal_thickness: "",
      lot_no: "",
      uom: "",
      is_qc: false,
      qc_nos: "",
      qc_length: "",
      qc_width: "",
      qc_topbottom_thickness: "",
      qc_width_thickness: "",
      qc_normal_thickness: "",
      qc_lot_no: "",
      tc_no: "",
      qc_status: "",
      qc_remarks: "",
      rej_quantity: 0,
      rej_length: "",
      rej_width: "",
      rate: "",
      amount: "",
      remarks: "",
    };

    if (!item.ui_id) {
      defaultItem.ui_id = `new_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      defaultItem.issue_detail_id = item.itemsDetails?._id;
      defaultItem.item_id = item._id;
    }

    return defaultItem;
  };

  const handleSelectedItems = (modalSelectedItems = []) => {
    setSelectedItems((prevItems) => {
      const prevMap = new Map(
        prevItems.map((item) => [item.issue_detail_id, item])
      );

      const result = [...prevItems];

      modalSelectedItems.forEach((modalItem) => {
        const issueDetailId = modalItem.itemsDetails?._id;

        if (!prevMap.has(issueDetailId)) {
          result.push({
            ...modalItem,
            ...createDetailedItem(modalItem),
            ui_id: `new_${issueDetailId}_${Date.now()}`,
            issue_detail_id: issueDetailId,
            item_id: modalItem._id,
            main_item_id: modalItem.itemsDetails?.item_id,
          });
        }
      });

      return result;
    });

    setShowModal(false);
  };

  const handleItemInputChange = (id, e) => {
    const isEdit = !!data?._id;

    let { name, value, type, checked } = e.target;
    if (type === "checkbox") value = checked;

    setSelectedItems((prev) =>
      prev.map((item) => {
        if (item.ui_id !== id) return item;

        const updatedItem = { ...item };

        const numericFields = [
          "receive_quantity",
          "quantity",
          "nos",
          "length",
          "width",
          "qc_length",
          "qc_width",
          "qc_status",
          "rej_quantity",
          "rej_length",
          "rej_width",
        ];

        const excludeFromNegativeCheck = ["receive_quantity", "quantity"];

        const newErrors = { ...errors };

        if (name === "qc_nos") {
          updatedItem.qc_nos = value;

          if (value !== "" && Number(value) < 0) {
            newErrors[`qc_nos_${id}`] = "QC No cannot be negative";
          } else {
            delete newErrors[`qc_nos_${id}`];
          }

          setErrors(newErrors);
          return updatedItem;
        }

        if (name === "is_qc") {
          updatedItem.is_qc = !!value;
          return updatedItem;
        }

        if (name === "qc_status") {
          updatedItem.qc_status = !!value;
          return updatedItem;
        }

        updatedItem[name] = numericFields.includes(name)
          ? value === ""
            ? ""
            : Number(value)
          : value;

        if (
          numericFields.includes(name) &&
          !excludeFromNegativeCheck.includes(name)
        ) {
          if (updatedItem[name] < 0) {
            updatedItem[name] = 0;
            newErrors[`${name}_${id}`] = "Value cannot be negative";
          } else {
            delete newErrors[`${name}_${id}`];
          }
        }

        const editablePendingQty = isEdit
          ? (item.itemsDetails?.remaining_erp_qty || 0) +
            (item.original_quantity || 0)
          : item.itemsDetails?.remaining_erp_qty || 0;

        let receiveQty =
          name === "receive_quantity"
            ? Number(updatedItem.receive_quantity)
            : Number(item.receive_quantity || 0);

        let acceptedQty =
          name === "quantity"
            ? Number(updatedItem.quantity)
            : Number(item.quantity || 0);

        if (name === "receive_quantity") {
          if (receiveQty > editablePendingQty) {
            newErrors[
              `receive_quantity_${id}`
            ] = `Receive quantity cannot exceed available quantity (${editablePendingQty})`;
            receiveQty = editablePendingQty;
          } else if (receiveQty <= 0) {
            newErrors[`receive_quantity_${id}`] =
              "Enter valid receive quantity";
          } else {
            delete newErrors[`receive_quantity_${id}`];
          }

          updatedItem.receive_quantity = receiveQty;
          updatedItem.quantity = receiveQty;
          delete newErrors[`quantity_${id}`];
        }

        if (name === "quantity") {
          if (acceptedQty > receiveQty) {
            newErrors[
              `quantity_${id}`
            ] = `Accepted quantity cannot exceed received quantity (${receiveQty})`;
            updatedItem.quantity = receiveQty;
          } else if (acceptedQty < 0) {
            newErrors[`quantity_${id}`] = "Enter valid accepted quantity";
          } else {
            delete newErrors[`quantity_${id}`];
          }
        }

        if (name === "uom") {
          if (!value) {
            newErrors[`uom_${id}`] = "UOM is required";
          } else {
            delete newErrors[`uom_${id}`];
          }
        }

        updatedItem.rej_quantity = Math.max(
          (updatedItem.receive_quantity || 0) - (updatedItem.quantity || 0),
          0
        );

        setErrors(newErrors);

        return updatedItem;
      })
    );
  };

  const confirmRemoveItem = async ({ ui_id, voucher_no, name }) => {
    const result = await Swal.fire({
      title: `Are you sure? ${voucher_no}`,
      text: `This ${name} will be removed.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, remove it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      removeItem(ui_id);

      await Swal.fire({
        title: "Removed!",
        text: "Item has been removed successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#0d6efd",
      });
    }
  };

  const removeItem = (id) => {
    setSelectedItems((prev) => {
      const itemToDelete = prev.find((item) => item.ui_id === id);

      if (itemToDelete && itemToDelete.ui_id.startsWith("edit_")) {
        setDeletedItems((d) => [...d, itemToDelete]);
      }

      return prev.filter((item) => item.ui_id !== id);
    });
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    if (selectedItems.length === 0) {
      toast.error("Please add at least one item!");
      return;
    }

    if (!data?._id) {
      const hasZeroRemaining = selectedItems.some(
        (item) => Number(item?.itemsDetails?.remaining_erp_qty || 0) === 0
      );

      if (hasZeroRemaining) {
        toast.error("Remaining quantity is zero. You cannot submit this form.");
        return;
      }
    }

    try {
      const payloadMain = {
        project_id,
        date: form.date,
      };

      const resMain = await dispatch(
        managetMaterialReceive({
          id: data?._id || null,
          payload: payloadMain,
        })
      );

      if (!resMain?.payload?.success) {
        toast.error(resMain?.payload?.message || "Operation failed");
        return;
      }

      const issue_main_id = resMain?.payload?.data?._id;

      const isExistingItem = (item) => item.ui_id?.startsWith("edit_");

      const payloadItems = selectedItems.map((item) => ({
        // ...(data?._id && { _id: item._id }),
        ...(isExistingItem(item) ? { _id: item._id } : {}),

        issue_main_id,
        project_id,
        main_item_id: item.main_item_id, // extra id item_id from modal data
        issue_detail_id: item.issue_detail_id,
        item_id: item.item_id,
        receive_quantity: item.receive_quantity,
        quantity: item.quantity,
        nos: item.nos,
        heat_no: item.heat_no,
        length: item.length,
        width: item.width,
        topbottom_thickness: item.topbottom_thickness,
        width_thickness: item.width_thickness,
        normal_thickness: item.normal_thickness,
        lot_no: item.lot_no,
        remarks: item.remarks,
        uom: item.uom,
        qc_nos: item.qc_nos,
        qc_length: item.qc_length,
        qc_width: item.qc_width,
        qc_topbottom_thickness: item.qc_topbottom_thickness,
        qc_width_thickness: item.qc_width_thickness,
        qc_normal_thickness: item.qc_normal_thickness,
        qc_lot_no: item.qc_lot_no,
        tc_no: item.tc_no,
        is_qc: item.is_qc,
        qc_remarks: item.qc_remarks,
        rej_quantity: item.rej_quantity,
        rej_length: item.rej_length,
        rej_width: item.rej_width,
        rate: item.rate,
        amount: item.amount,
      }));

      deletedItems.forEach((deletedItem) => {
        if (deletedItem.ui_id?.startsWith("edit_")) {
          payloadItems.push({
            _id: deletedItem._id,
            issue_main_id,
            deleted: true,
          });
        }
      });

      const resItems = await dispatch(
        managetMaterialReceiveItem({ data: payloadItems })
      );

      if (!resItems?.payload?.success) {
        toast.error(resItems?.payload?.message || "Failed to save items");
        return;
      }

      toast.success(
        data?._id
          ? "Material Receive Updated Successfully!"
          : "Material Receive Saved Successfully!"
      );

      setDeletedItems([]);
      navigate("/user/project-store/item-receive-management");
    } catch (err) {
      console.error("Submit error:", err);
      toast.error("An error occurred while saving");
    }
  };

  const handleReset = () => {
    setSelectedItems([]);
    setDeletedItems([]);
    setForm({ date: moment().format("YYYY-MM-DD") });
  };

  const breadcrumbItems = [
    { label: "Dashboard", link: "/user/project-store/dashboard" },
    {
      label: "Material Receipt",
      link: "/user/project-store/item-receive-management",
    },
    {
      label: data?._id ? "Edit Material Receipt" : "Add Material Receipt",
      active: true,
    },
  ];

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          {/* Main Form Section */}
          <div className="row g-3">
            <div className="col-sm-12">
              <div className="card shadow-sm">
                <div className="card-body p-4">
                  <h4 className="mb-4">
                    {data?._id
                      ? "Edit Material Receipt"
                      : "Add Material Receipt"}
                  </h4>

                  {/* Date Field */}
                  <div className="row g-4 mb-4">
                    <div className="col-md-4">
                      <label className="form-label fw-bold">
                        Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="date"
                        value={form.date}
                        onChange={handleChange}
                      />
                      {errors.date && (
                        <span
                          className="text-danger mt-1 ms-2"
                          style={{ fontSize: "13px" }}
                        >
                          {errors.date}
                        </span>
                      )}
                    </div>

                    {data?._id && (
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Voucher No</label>
                        <input
                          type="text"
                          readOnly
                          className="form-control"
                          name="voucher_no"
                          value={data?.voucher_no}
                        />
                      </div>
                    )}

                    {data?._id && (
                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Received By
                        </label>
                        <input
                          type="text"
                          readOnly
                          className="form-control"
                          name="modify_by"
                          value={data?.received_by?.user_name || "-"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Add Item Button */}
              <div className="row mt-3 ">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body text-end bg-transparent">
                      <Button
                        variant="primary"
                        onClick={() => setShowModal(true)}
                      >
                        <i className="fas fa-plus me-2"></i>Add Item
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Selected Items Section */}
              <SelectedItemsForm
                items={selectedItems}
                unitData={unitData}
                onItemChange={handleItemInputChange}
                onRemoveItem={confirmRemoveItem}
                isEditMode={!!data?._id}
                errors={errors}
              />

              {/* Submit / Reset */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="col-12 text-end">
                        <div className="doctor-submit text-end">
                          <button
                            type="button"
                            className="btn btn-primary submit-form me-2"
                            onClick={handleSubmit}
                          >
                            {data?._id ? "Update" : "Submit"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary cancel-form"
                            onClick={handleReset}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>

      {/* Modal for selecting items */}
      <ItemSelectionModal
        // materalItemData={materalItemData}
        show={showModal}
        onHide={() => setShowModal(false)}
        sendSelectedItems={handleSelectedItems}
        preSelectedItems={selectedItems}
        isEditMode={!!data?._id}
      />
    </div>
  );
};

export default ManageMaterialReceive;
